var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Typography, Stack, Card, Box, Divider, Switch, Button, Link, FormLabel, FormControl, Input, ModalClose, Modal, ModalDialog, DialogTitle, DialogContent, Alert, Chip } from '@mui/joy';
import DialerSipIcon from '@mui/icons-material/DialerSip';
import { useTwilio } from '../../../../../../data/hooks/useTwilio';
import { useWebsite } from '../../../../../../data/hooks/useWebsite';
import { useRequest } from '../../../../../../hooks/useRequest';
export default function SIP(props) {
    var _this = this;
    var _a, _b;
    var flow = props.flow, onError = props.onError, onSIPIsEnabledChange = props.onSIPIsEnabledChange, onSIPConfigurationUpdate = props.onSIPConfigurationUpdate;
    var twilio = useTwilio();
    var _c = useState(false), isSIPCreating = _c[0], setIsSIPCreating = _c[1];
    var _d = useState(false), isPasswordRegenerating = _d[0], setIsPasswordRegenerating = _d[1];
    var _e = useState(false), isPasswordModalOpen = _e[0], setIsPasswordModalOpen = _e[1];
    var limitation = useWebsite().limitation;
    var request = useRequest();
    var createSIPConfig = function () { return __awaiter(_this, void 0, void 0, function () {
        var config, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsSIPCreating(true);
                    return [4 /*yield*/, twilio.createSipDomain(flow.id)];
                case 1:
                    config = _a.sent();
                    onSIPConfigurationUpdate(config);
                    setIsPasswordModalOpen(true);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    onError("Something went wrong while creating the SIP configuration.");
                    return [3 /*break*/, 4];
                case 3:
                    setIsSIPCreating(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var regenerateSIPPassword = function () { return __awaiter(_this, void 0, void 0, function () {
        var newPassword, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsPasswordRegenerating(true);
                    return [4 /*yield*/, twilio.regenerateSipPassword(flow.sipDeploymentConfig.id)];
                case 1:
                    newPassword = _a.sent();
                    onSIPConfigurationUpdate(__assign(__assign({}, flow.sipDeploymentConfig), { password: newPassword }));
                    setIsPasswordModalOpen(true);
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    console.log(error_2);
                    onError("Something went wrong while regenerating the SIP password.");
                    return [3 /*break*/, 4];
                case 3:
                    setIsPasswordRegenerating(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCopyClick = function () {
        var inputValue = flow.sipDeploymentConfig.password;
        navigator.clipboard.writeText(inputValue);
    };
    var manageBilling = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.post('/payments/portal/session?customerId=' + (limitation === null || limitation === void 0 ? void 0 : limitation.stripeCustomerId))];
                case 1:
                    response = _a.sent();
                    url = response.data.url;
                    window.location.href = url;
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Card, { children: [_jsx(Box, __assign({ sx: { mb: 1 } }, { children: _jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }, { children: [_jsxs(Stack, __assign({ spacing: 1, sx: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(DialerSipIcon, { sx: { mr: 1 } }), _jsx(Typography, __assign({ level: "title-md" }, { children: "SIP" })), _jsx(Chip, __assign({ sx: { ml: 1 }, color: "primary" }, { children: "Voice" }))] })), _jsx(Stack, __assign({ spacing: 2, sx: { pr: 2 } }, { children: _jsxs(Typography, __assign({ level: "body-sm" }, { children: ["Connect the AI Agent to your contact center solution using SIP.", _jsx(Link, __assign({ sx: { ml: 1 } }, { children: "Learn More" }))] })) }))] })), limitation && limitation.plan === 'Pro' ?
                            _jsx(Switch, { checked: (_a = flow.sipDeploymentConfig) === null || _a === void 0 ? void 0 : _a.isEnabled, onChange: onSIPIsEnabledChange, size: "lg", variant: "outlined" })
                            :
                                _jsx(Button, __assign({ color: "neutral", variant: "soft", onClick: manageBilling }, { children: "Upgrade to Pro" }))] })) })), ((_b = flow.sipDeploymentConfig) === null || _b === void 0 ? void 0 : _b.isEnabled) &&
                _jsxs(_Fragment, { children: [_jsx(Divider, {}), flow.sipDeploymentConfig.domainName ?
                            _jsxs(_Fragment, { children: [_jsxs(Stack, __assign({ spacing: 2, sx: { my: 1 } }, { children: [_jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(FormLabel, { children: "SIP URI" }), _jsx(Typography, __assign({ level: "body-sm" }, { children: "Use this URI to transfer calls from your call center solution to the AI Agent via SIP INVITE." })), _jsx(FormControl, __assign({ sx: { display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 } }, { children: _jsx(Input, { size: "sm", value: flow.sipDeploymentConfig.domainName, readOnly: true }) }))] })), _jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(FormLabel, { children: "SIP Username" }), _jsx(Typography, __assign({ level: "body-sm" }, { children: "You need to authenticate with the generated username and password when performing a SIP INVITE." })), _jsx(FormControl, __assign({ sx: { display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 } }, { children: _jsx(Input, { size: "sm", value: flow.sipDeploymentConfig.userName, readOnly: true }) }))] })), _jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(FormLabel, { children: "SIP Password" }), _jsx(Typography, __assign({ level: "body-sm" }, { children: "We do not store passwords, so if you lose yours, you will need to regenerate it." })), _jsx(FormControl, __assign({ sx: { display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 } }, { children: _jsx(Button, __assign({ sx: { alignSelf: 'flex-start' }, variant: 'soft', color: 'neutral', onClick: regenerateSIPPassword, loading: isPasswordRegenerating }, { children: "Regenerate Password" })) }))] }))] })), _jsx(Modal, __assign({ open: isPasswordModalOpen, onClose: function () { return setIsPasswordModalOpen(false); }, hideBackdrop: true }, { children: _jsxs(ModalDialog, __assign({ variant: "outlined" }, { children: [_jsx(ModalClose, {}), _jsx(DialogTitle, { children: "SIP Password" }), _jsx(DialogContent, __assign({ sx: { py: 2 } }, { children: _jsxs(Stack, __assign({ spacing: 2 }, { children: [_jsx(Alert, __assign({ variant: "soft", color: "primary" }, { children: "Make sure to copy the SIP password as we do not store it." })), _jsx(Input, { value: flow.sipDeploymentConfig.password, readOnly: true, endDecorator: _jsx(Button, __assign({ variant: "soft", color: "neutral", onClick: handleCopyClick }, { children: "Copy" })) })] })) }))] })) }))] })
                            :
                                _jsx(Stack, __assign({ spacing: 2, sx: { my: 1 } }, { children: _jsx(Button, __assign({ sx: { alignSelf: 'flex-start' }, onClick: createSIPConfig, loading: isSIPCreating }, { children: "Initialize SIP Configuration" })) }))] })] }));
}
